import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Crosshair } from "@phosphor-icons/react";
import LeadDashboard from "./leads/LeadDashboard";
import LeadProspects from "./leads/LeadProspects";
import LeadPipeline from "./leads/LeadPipeline";
import LeadCampaigns from "./leads/LeadCampaigns";
import LeadSync from "./leads/LeadSync";
import LeadSettings from "./leads/LeadSettings";

export default function AdminLeads() {
  const [settings, setSettings] = useState(null);
  const [tab, setTab] = useState("dashboard");
  const [campaignId, setCampaignId] = useState(null);
  const load = () => api.get("/admin/leads/settings").then(({ data }) => setSettings(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!settings) return <div className="text-muted text-sm animate-pulse">Chargement…</div>;

  return (
    <div className="space-y-5" data-testid="admin-leads-page">
      <div>
        <div className="flex items-center gap-2 text-accent"><Crosshair size={18} weight="bold" /><span className="overline !text-accent">Usage interne — équipe commerciale</span></div>
        <h1 className="font-display text-3xl font-bold text-fg mt-1">Lead Intelligence</h1>
        <p className="text-sm text-muted mt-1">ESN françaises à fort potentiel pour l'offre interKO à 29 €/mois — sources officielles, score explicable, aucun envoi automatique.</p>
      </div>
      {!settings.enabled ? (
        <div className="space-y-4">
          <p className="text-sm text-amber-500" data-testid="lead-disabled-notice">Le module est désactivé.</p>
          <LeadSettings settings={settings} reload={load} />
        </div>
      ) : (
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="bg-surface border border-border">
            <TabsTrigger value="dashboard" data-testid="lead-tab-dashboard">Tableau de bord</TabsTrigger>
            <TabsTrigger value="prospects" data-testid="lead-tab-prospects">Prospects</TabsTrigger>
            <TabsTrigger value="pipeline" data-testid="lead-tab-pipeline">Suivi commercial</TabsTrigger>
            <TabsTrigger value="campaigns" data-testid="lead-tab-campaigns">Campagnes</TabsTrigger>
            <TabsTrigger value="sync" data-testid="lead-tab-sync">Synchronisation</TabsTrigger>
            <TabsTrigger value="settings" data-testid="lead-tab-settings">Réglages</TabsTrigger>
          </TabsList>
          <TabsContent value="dashboard" className="mt-4"><LeadDashboard /></TabsContent>
          <TabsContent value="prospects" className="mt-4">
            <LeadProspects meta={settings} onCampaignCreated={(id) => { setCampaignId(id); setTab("campaigns"); }} />
          </TabsContent>
          <TabsContent value="pipeline" className="mt-4">{tab === "pipeline" && <LeadPipeline />}</TabsContent>
          <TabsContent value="campaigns" className="mt-4"><LeadCampaigns openId={campaignId} setOpenId={setCampaignId} /></TabsContent>
          <TabsContent value="sync" className="mt-4"><LeadSync /></TabsContent>
          <TabsContent value="settings" className="mt-4"><LeadSettings settings={settings} reload={load} /></TabsContent>
        </Tabs>
      )}
    </div>
  );
}
